import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Modal from 'react-bootstrap/Modal';
import { Divider } from '@material-ui/core';

import CloseButton from 'components/CustomButtons/CloseButton';
import { getSelectedOrder } from 'reducers/ShoppingCart';
import { setOrderEmployeeID } from 'actions/ShoppingCart';
import {
  getCommissionable,
  getOtherCommissionable,
} from 'reducers/cachedItems/employees';
import '../ProductForm/ProductForm.scss';
import { addWarning } from 'actions/Error';

const ProductCommissionsForm: FC<{ onClose: () => void }> = ({ onClose }) => {
  const order = useSelector(getSelectedOrder);
  const recommendedCommissions = useSelector(getCommissionable);
  const nonRecommendedCommissions = useSelector(getOtherCommissionable);
  const dispatch = useDispatch();
  const setCommission = id => {
    dispatch(setOrderEmployeeID(id, order?.orderIndex));
  };
  const { t } = useTranslation('shoppingCart');

  useEffect(() => {
    if (!order) {
      dispatch(addWarning(t('commission.productNotFoundClosingModal')));
      onClose();
    }
  }, [dispatch, onClose, order, t]);

  return (
    <>
      <Modal.Header>
        <span style={{ fontWeight: 700, fontSize: '1.75em' }}>
          {t('commission.title')}
        </span>

        <div style={{ flex: 1 }} />
        <CloseButton action={onClose} />
      </Modal.Header>
      <Modal.Body>
        <div className="product-order-form">
          <div className="product-body">
            <div className="commission">
              <ToggleButtonGroup
                name="commission"
                type="radio"
                value={order?.employeeID}
                onChange={setCommission}
                className="btn-group-product-commissions"
              >
                {recommendedCommissions.map(
                  ({ employeeID, firstName, lastName }) => (
                    <ToggleButton
                      variant="light"
                      key={employeeID}
                      value={employeeID}
                      disabled={!employeeID}
                    >
                      <div className="btn-text">
                        {firstName} {lastName}
                      </div>
                    </ToggleButton>
                  ),
                )}
              </ToggleButtonGroup>
              <Divider
                style={{
                  marginTop: '1em',
                  marginBottom: '1em',
                }}
              />
              <ToggleButtonGroup
                name="commission"
                type="radio"
                value={order?.employeeID}
                onChange={setCommission}
                className="btn-group-product-commissions"
              >
                {nonRecommendedCommissions.map(
                  ({ employeeID, firstName, lastName }) => (
                    <ToggleButton
                      variant="light"
                      key={employeeID}
                      value={employeeID}
                      disabled={!employeeID}
                    >
                      <div className="btn-text">
                        {firstName} {lastName}
                      </div>
                    </ToggleButton>
                  ),
                )}
              </ToggleButtonGroup>
            </div>
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default ProductCommissionsForm;
